import React from "react";
import Button from "react-bootstrap/Button";
import { ButtonProps } from "react-bootstrap/Button";
import "./index.scss";
import classNames from "classnames";
import { InfoTooltip } from "../../global/_infoTooltip";

interface PDLButtonProps extends ButtonProps {
  children: React.ReactNode;
  className?: string | "";
  tooltipDisabledAlert?: React.ReactNode;
  onDisabledTooltipChange?: (open: boolean) => void;
}

const PDLButton: React.FC<PDLButtonProps> = ({
  children,
  className = "",
  tooltipDisabledAlert,
  onDisabledTooltipChange,
  disabled,
  ...props
}) => {
  const button = (
    <Button
      {...props}
      disabled={disabled}
      className={classNames("pdl_dna_button", className)}
      as={props.as ?? "button"}
    >
      {children}
    </Button>
  );

  if (!tooltipDisabledAlert) {
    return button;
  }

  return (
    <InfoTooltip
      content={tooltipDisabledAlert}
      showOnDisabled
      {...(onDisabledTooltipChange
        ? { onOpenChange: onDisabledTooltipChange }
        : {})}
    >
      {button}
    </InfoTooltip>
  );
};

export default PDLButton;
